import React, { Component } from 'react';
import CarouselComisiones from './components/CarouselComisiones';
import './index.css';

class Unete extends Component {
  constructor(props){
    super(props);
  }

  render() {
    return (
      <CarouselComisiones lan={this.props.lan} id="comisiones"/>
    );
  }
}

export default Unete
